import React from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
const NAV = [
  { p: '/home', l: 'Home', i: <svg viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { p: '/invest', l: 'Invest', i: <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg> },
  { p: '/team', l: 'Team', i: <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg> },
  { p: '/income', l: 'Income', i: <svg viewBox="0 0 24 24"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg> },
  { p: '/rfcoin', l: 'RF Coin', i: <svg viewBox="0 0 24 24"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg> }
];
export default function BottomNav() {
  const loc = useLocation(), nav = useNavigate();
  return (
    <motion.nav className="bnav" initial={{ y: 100 }} animate={{ y: 0 }} transition={{ delay: 0.2, type: 'spring', stiffness: 180, damping: 22 }}>
      {NAV.map(n => {
        const on = loc.pathname === n.p;
        return (
          <div key={n.p} className={`nav-item ${on ? 'on' : ''}`} onClick={() => nav(n.p)}>
            <div style={{ position: 'relative' }}>{n.i}</div>
            <span>{n.l}</span>
            {on && <motion.div layoutId="nav-indicator" style={{ position: 'absolute', bottom: 2, width: 4, height: 4, borderRadius: '50%', background: 'var(--cyan)', boxShadow: '0 0 8px var(--cyan)' }} transition={{ type: 'spring', stiffness: 300, damping: 25 }} />}
          </div>
        );
      })}
    </motion.nav>
  );
}
